import React, { Component } from 'react';
import {map, reject} from 'lodash';
import {message, Popconfirm} from 'antd'
import doody_dog from '../../../../../Assets/images/doody_dog.png';
import moment from 'moment-timezone'
import AddDog from '../Common/AddDog'
import Loader from '../../../../Common/Component/Loader'

const displaySafetyInfo = [
  {key: 'is_friendly', value: 'This dog is friendly'},
  {key: 'can_clean_if_in_yard', value: 'Clean with dog in yard'},
  {key: 'can_treat', value: 'We can give this dog treats'},
  {key: 'has_doggy_door', value: 'Doggy Door?'},
  {key: 'is_dogs_outside', value: 'Left outside when no one is home?'},
]

class Dogs extends Component {
  state = {
    petList: [],
    showDrawer: false,
    isEdit: false,
    dogInfo: {},
    loader: false,
    serviceOrder: {},
    service_order_uuid: ''
  }

  componentDidMount = () => {
    const {customerId, getPets, getServiceOrder} = this.props;
    this.props.onClearFromOverview();
    if (customerId) {
      this.setState({loader: true});
      getPets({service_order__user__uuid: customerId}) // get pet list
      getServiceOrder({user__uuid: customerId}) // get service orders
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    const {petList, serviceOrder} = this.state;
    this.setState({loader: false});
    // get service order
    if (Object.keys(nextProps?.serviceOrder?.data).length > 0
      && JSON.stringify(nextProps?.serviceOrder?.data) !== JSON.stringify(serviceOrder)) {
      this.setState({serviceOrder: nextProps?.serviceOrder?.data});
    }
    
    // get pet list
    if (Object.keys(nextProps?.pet?.petList).length > 0
      && JSON.stringify(nextProps?.pet?.petList) !== JSON.stringify(this.props.pet?.petList)) {
      this.setState({petList: nextProps?.pet?.petList?.results, service_order_uuid: nextProps?.pet?.petList?.results?.[0]?.service_order_uuid});
    } else if (Object.keys(nextProps?.pet?.petList).length > 0
      && JSON.stringify(nextProps?.pet?.petList) === JSON.stringify(this.props.pet?.petList)) {
      this.setState({petList: nextProps?.pet?.petList?.results, service_order_uuid: nextProps?.pet?.petList?.results?.[0]?.service_order_uuid});
    }

    // add pet
    if (Object.keys(nextProps?.pet?.addPet).length > 0 && JSON.stringify(nextProps?.pet?.addPet) !== JSON.stringify(this.props.pet?.addPet)) {
      this.setState({petList: [...petList, nextProps?.pet?.addPet]});
    }

    // edit pet
    if (Object.keys(nextProps?.pet?.editPet).length > 0 && JSON.stringify(nextProps?.pet?.editPet) !== JSON.stringify(this.props.pet?.editPet)) {
      const idx = petList.findIndex(obj => obj.uuid === nextProps?.pet?.editPet?.uuid);
      if (idx > -1) {
        Object.assign(petList[idx], nextProps?.pet?.editPet)
        this.setState({petList});
      }
    }

    // delete pet
    if (Object.keys(nextProps?.pet?.deletePet).length > 0) {
      // this.setState({petList: nextProps?.pet?.addPet});
    }
  }

  // toggle drawer
  toggleDrawer = (value, isEdit = false) => {
    this.setState({showDrawer: value, isEdit})
  }

  // on delete pet
  onDeletePet = (item) => {
    const {petList} = this.state;
    this.props.deletePet(item.uuid);
    this.setState({ loader: true });
    this.setState({
      petList: reject(petList, function (el) { return el.uuid === item.uuid })
    })
  }

  // render pet
  renderPet = (item, i) => {
    return (
      <div className="card" key={i}>        
        <div className="card-body">
          <div className="flex ai-center flex-start">
            <div className={item.photo ? 'profile-wrap md-profile' : 'profile-wrap md-profile'}>
              <figure>
                {item.photo ? <img src={item.photo} alt="" /> : <img src={doody_dog} alt="" />}
              </figure>
            </div>
            <div className="flex flex-column">
              <h5>{item.name}</h5>
              <span>{item.breed || '---'}</span>
              <span>{item.birthday ? moment(item.birthday).format('MM/DD/YYYY') : '--'}</span>
            </div>
          </div>

          <div className="mt-30">
            <div className="dog_address">
              <b>Additional Information</b>
              <span className="dadd d-block">{item?.additional_info || '-'}</span>
            </div>
            <hr/>
            <ul className="check-list">
              {map(displaySafetyInfo, (obj) => {
                return (
                  <li>
                    {item[obj.key] ?
                      <i className="las la-check-circle success"></i> :
                      <i className="las la-times-circle red"></i>
                    }
                    <b className="wrap">{obj.value}</b>
                  </li>
                )
              })}
            </ul>
            <hr/>
            <div className="dog_address">
              <b>Service Addresses</b>
              <span className="dadd d-block">{item.service_address}</span>
            </div>
            <hr/>
          </div>
          <div className="flex">
            <Popconfirm
              title="Are you sure delete this dog?"
              onConfirm={() => this.onDeletePet(item)}
              okText="Yes"
              cancelText="No">
              <span className="btn plain-btn">Delete</span>
            </Popconfirm>
            <span className="btn plain-btn"
              onClick={() => this.setState({dogInfo: item}, () => this.toggleDrawer(true, true))}>
              Edit
            </span>
          </div>
        </div>        
      </div>
    )
  }

  renderAddDogBox = () => {
    return (
      <div className="card add-card">
        <h5>Add Another Dog</h5>
        <p>This will increase the quote</p>
        <button
          className={"btn btn-warning lg-btn"}
          onClick={() => {this.setState({dogInfo: {}}, () => this.toggleDrawer(true))}}
        >Add Dog</button>
      </div>
    )
  }

  render() {
    const {petList, showDrawer, isEdit, dogInfo, loader, serviceOrder, service_order_uuid} = this.state;
    return (
      <div className="block-row dogs-block">
        <div className="container">
          {loader && <Loader />}
          <div className="flist">
            {
              map(petList, this.renderPet)
            }
            {this.renderAddDogBox()}
          </div>
          <AddDog
            isProcessing={(value) => this.setState({loader: value})}
            service_order_uuid={service_order_uuid}
            visible={showDrawer}
            closeDrawer={() => this.toggleDrawer(false)}
            isEdit={isEdit}
            dogInfo={dogInfo}
            serviceOrder={serviceOrder}
            getPets={() => this.props.getPets({service_order__user__uuid: this.props.customerId})}
            addPet={this.props.addPet}
            updatePet={this.props.updatePet}
            updatePartialServiceOrder={this.props.updatePartialServiceOrder}
          />
        </div>
      </div>
    );
  }
}

export default Dogs;
